module.exports = {
	baseRouter: '',
	virtualList: [{
			title: '',
			list: [{
					name: 'Fraser Suites Hanoi - 1BR Executive',
					img: '0.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=a1f4ad7e_1aIx_b6f9',
				}, {
					name: 'Fraser Suites Hanoi – Studio Executive',
					img: '1.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=3bb44190_XiPs_b6f9',
				}, {
					name: 'Fraser Suites Hanoi - 1BR Deluxe',
					img: '2.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=3f16ed12_uKPd_b6f9',
				},
				{
					name: 'Fraser Suites Hanoi - 2BR Deluxe',
					img: '3.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=e53fe1f6_yrkT_b6f9',
				}, {
					name: 'Fraser Suites Hanoi - 3BR Deluxe',
					img: '4.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=95457484_7cwg_b6f9',
				}, {
					name: 'Fraser Suites Hanoi - 3BR Executive',
					img: '5.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=05ea7976_wEyW_b6f9',
				},
				{
					name: 'Fraser Suites Hanoi - 2BR Executive',
					img: '6.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=98dfdfe8_wv6a_b6f9',
				},
				{
					name: 'Fraser Suites Hanoi - Studio Deluxe',
					img: '7.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=4b8da17c_AKXe_b6f9',
				}, {
					name: 'Fraser Suites Hanoi - Studio Deluxe',
					img: '8.jpg',
					link: 'https://beyond.3dnest.biz/play/?m=0051c2e8_VbXW_b6f9',
				},
			],
		},
		// {
		// 	title:'TOWER B',
		// 	list:[
		// 		{
		// 			name:'STUDIO: 37m2',
		// 			img:'3.jpg',
		// 			link:'https://beyond.3dnest.biz/silversea/newhouse/?m=aabf4938_9pSh_b6f9_CJU&lang=3',
		// 		}, {
		// 			name:'ONE BEDROOM: 55sqm',
		// 			img:'4.jpg',
		// 			link:'https://beyond.3dnest.biz/silversea/newhouse/?m=a8eb5d74_IgLl_b6f9_5dW&lang=3&_floor=0',
		// 		}, {
		// 			name:'ONE BEDROOM: 55sqm',
		// 			img:'5.jpg',
		// 			link:'https://beyond.3dnest.biz/silversea_dev/takelook/?m=aabf4938_9pSh_b6f9&lang=3',
		// 		},
		// 	],
		// },
	],
};